import { getCertificate } from './states';

export const services = {
  getCertificate,
};
